import { render, staticRenderFns } from "./MemoDeal.vue?vue&type=template&id=c836b414&scoped=true&"
import script from "./MemoDeal.vue?vue&type=script&lang=js&"
export * from "./MemoDeal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c836b414",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/tgs-automation/tgs-automation/mojaweb/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c836b414')) {
      api.createRecord('c836b414', component.options)
    } else {
      api.reload('c836b414', component.options)
    }
    module.hot.accept("./MemoDeal.vue?vue&type=template&id=c836b414&scoped=true&", function () {
      api.rerender('c836b414', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/MemoDeal.vue"
export default component.exports